import { getGameStoreStatsInfo } from '@/pages/opinion/services';
import { dealwithNewOldData } from '@/pages/opinion/utils';
import { DBO_TM } from '@op/utils/format';
import moment from 'moment';
import { useEffect, useState } from 'react';

const defaultStatsData = {
  'google play': { selected: [], lifetime: [] },
  'app store': { selected: [], lifetime: [] },
  taptap: { selected: [], lifetime: [] },
};
export default function useGetStoreStats({
  keepParams,
  splitRegion = true,
  needLink = false,
  channel = ['app store', 'google play', 'taptap'],
}: {
  keepParams: any;
  splitRegion?: boolean;
  needLink?: boolean;
  channel?: Array<'app store' | 'google play' | 'taptap'>;
}) {
  const [userScore, setUserScore] = useState(
    JSON.parse(JSON.stringify(defaultStatsData)),
  );
  const [userScoreTable, setUserScoreTable] = useState<Array<any>>([]);
  const [userScoreLoading, setUserScoreLoading] = useState(false);
  const [userScoreApiError, setUserScoreApiError] = useState(false);
  const requestUserScore = () => {
    setUserScoreLoading(true);
    setUserScoreApiError(false);
    getGameStoreStatsInfo({
      ...keepParams,
      channel: channel,
      channel_type: 'comments',
      types: ['lifetime', 'selected'],
      need_link: needLink,
      need_region: splitRegion,
      is_today: DBO_TM.isToday(keepParams), // 前端判断是否是今天
    }).then((data: any) => {
      let globalResult = JSON.parse(JSON.stringify(defaultStatsData));

      let list = data || [];
      let info: any = {};
      list?.forEach(
        ({
          new_list,
          type,
          old_list,
          link_of_start_time,
          link_of_end_time,
        }: any) => {
          let realNewList =
            new_list?.filter(
              (item: { region: string }) => item.region !== 'global',
            ) || [];
          realNewList.forEach((item: { region: string; channel: any }) => {
            // 这个是计算global的数据
            if (item.region === '') {
              let channel = item.channel;
              globalResult[channel] = {
                ...(globalResult[channel] || {}),
                [type]: { ...item },
              };
            }
          });
          let list = realNewList;
          if (needLink) {
            // todo 这一块没有经过验证
            list = dealwithNewOldData(
              realNewList,
              old_list,
              splitRegion ? 'region' : 'channel',
              ['score'],
              (item, oldItem: any) => {
                let obj: any = { oldScore: oldItem?.score || 0 };
                if (item.region === '') {
                  obj['region'] = 'global';
                }

                return obj;
              },
            );
          }
          if (splitRegion) {
            list.forEach((item: { region: any; channel: any }) => {
              let { region, channel } = item;
              region = region || 'global';
              if (!info[region]) {
                info[region] = { region };
              }
              info[region][channel + '-' + type] = {
                ...item,
                oldTime: [link_of_start_time, link_of_end_time],
              };
            });
          }
        },
      );
      setUserScoreTable(Object.values(info));
      setUserScore(globalResult);
      setUserScoreLoading(false);
    });
  };

  useEffect(() => {
    if (keepParams && keepParams.entity_type === 'mobile') {
      requestUserScore();
    }
  }, [keepParams, channel]);

  return {
    userScore,
    userScoreLoading,
    userScoreApiError,
    userScoreTable,
  };
}
